var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKeySetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7774 13.895L9.75605 6.83112C10.4505 5.04575 10.0647 2.94987 8.5987 1.475C7.05555 -0.077502 4.74083 -0.388002 2.88906 0.465873L6.20682 3.80375L3.8921 6.1325L0.497181 2.79462C-0.428707 4.65762 -0.0429203 6.98637 1.50023 8.53887C2.96621 10.0137 5.04946 10.4019 6.82408 9.70325L13.8454 16.7671C14.154 17.0776 14.617 17.0776 14.9256 16.7671L16.7002 14.9817C17.086 14.6712 17.086 14.1279 16.7774 13.895Z",
    fill: "#A9CC13"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeySetting);
export default __webpack_public_path__ + "static/media/key_setting.2bc6d93f.svg";
export { ForwardRef as ReactComponent };